<template>
  <div class="positionfixed">
    <Header></Header>
  <div class="pc_all FreeCreation">
    <div class="pc_all_content">
      <!-- 导航部分 -->
      <div
        class="FreeCreationNav animate__animated animate__fadeInDown"
        style="animation-delay: 0.2s"
      >
        <div class="FreeCreationNav_btn">
          <router-link to="/ailogo/FreeCreation/FreeCreation" class="FreeCreationNav_list font20">
            <span class="iconfont icon-chuangzuozhezhongxin"></span>自由创作
          </router-link>
          <router-link to="/ailogo/LetterLogo/LetterLogo" class="FreeCreationNav_list font20 active">
            <span class="iconfont icon-fa-buysellads"></span>字母LOGO
          </router-link>
          <router-link to="/ailogo/SameCreation/SameCreation" class="FreeCreationNav_list font20">
            <span class="iconfont icon-AItongkuan"></span>同款创作
          </router-link>
        </div>
      </div>

      <div class="Keyword">
        <div class="KeywordTop">
          <div class="KeywordTop_left">
            <div
              class="KeywordTop_title font20 animate__animated animate__fadeInDown"
              style="animation-delay: 0.4s"
            >
              关键词
            </div>
            <div
              class="KeywordTop_left_content animate__animated animate__fadeInDown"
              style="animation-delay: 0.6s"
            >
              <textarea
                v-model="inputText"
                :placeholder="placeholder"
                class="font16"
                @input="updateCharCount"
                maxlength="150"
              ></textarea>
              <div class="left_content_btn font16">
                <div class="content_btn_lists font16">{{ charCount }}</div>
                /
                <div class="content_btn_list font16">150</div>
                <div class="content_btn_icon"></div>
                <div class="content_btn_right font16" @click="clearInput">
                  <span class="iconfont icon-a-qingkong1"></span>清空
                </div>
              </div>
            </div>

            <div
              :class="['KeywordAI  animate__animated animate__fadeInDown', { active: isActive }]"
              style="animation-delay: 0.8s"
            >
              <div class="KeywordAI_top">
                <div class="KeywordAI_top_btn" @click="handleKeywordAIButtonClick">
                  <img alt="" src="@a/ailogo/images/bn5.png" />
                  <span class="top_btn_title1">AI继续生成</span>
                  <span class="top_btn_title2">AILOGO智能关键词生成中...</span>
                  <div class="la-pacman la-1x">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <div class="KeywordAI_top_title font16">
                  我们为您生成"小馋猫烤肉拌饭"的LOGO创作优质关键词参考
                </div>
              </div>
              <div class="KeywordAI_bottom">
                <div class="KeywordAI_bottom_list">
                  <div class="bottom_list_title font16">
                    logo元素<span class="font16">(建议选1-3个)</span>
                  </div>
                  <div class="bottom_list_txt">
                    <span
                      v-for="item in logoItems"
                      :key="item"
                      :class="['list_txt_li', { selected: selectedItems.includes(item) }]"
                      @click="selectItem(item)"
                      >{{ item }}</span
                    >
                  </div>
                </div>
                <div class="KeywordAI_bottom_list">
                  <div class="bottom_list_title font16">
                    品牌情绪化<span class="font16">(建议选1个)</span>
                  </div>
                  <div class="bottom_list_txt">
                    <span
                      v-for="item in emotionItems"
                      :key="item"
                      :class="['list_txt_li', { selected: selectedItems.includes(item) }]"
                      @click="selectItem(item)"
                      >{{ item }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="KeywordTop_right">
            <div
              class="KeywordTop_title font20 animate__animated animate__fadeInDown"
              style="animation-delay: 0.2s"
            >
              示例LOGO
            </div>
            <div
              class="KeywordTop_right_content animate__animated animate__fadeInDown"
              style="animation-delay: 0.6s"
            >
              <div class="right_content_list">
                <div class="content_list_img"><img alt="" src="@a/ailogo/images/bg8.jpg" /></div>
                <div class="content_list_title font16">竹子，篮子，新鲜的</div>
              </div>
              <div class="right_content_list">
                <div class="content_list_img"><img alt="" src="@a/ailogo/images/bg9.jpg" /></div>
                <div class="content_list_title font16">萌芽，女孩侧影，圆形，文艺的</div>
              </div>
              <div class="right_content_list">
                <div class="content_list_img"><img alt="" src="@a/ailogo/images/bg10.jpg" /></div>
                <div class="content_list_title font16">农产品，农民，阳光的</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 按钮部分 -->
      <div class="Btn animate__animated animate__fadeInDown" style="animation-delay: 1s">
        <div class="Btn_prev font20" @click="goBack">
          <span class="iconfont icon-xiangyou"></span>上一步
        </div>
        <router-link
          to="/ailogo/LogoCenter/LetterLogoCenter" :class="['Btn_next', { active: inputText.length > 0 }]" class="font20">
          <div class="form_btn_po">生成<span class="iconfont icon-xiangyou"></span></div>
        </router-link>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from '@c/header/header'

export default {
  data() {
    return {
      inputText: '',
      placeholder:
        '请输入您想在LOGO中看到的元素，建议输入3个及以上的关键 比如“龙游车行”可以输入: 跑车，龙，环形等...',
      logoItems: ['稻田', '字母', '波浪', '河流', '山峰', '星星', '桥梁', '灯塔', '帆船', '风车'],
      emotionItems: ['美好的', '科技的', '鲜明的', '简洁的', '醒目的'],
      selectedItems: [],
      isActive: false
    }
  },
  components: {
    Header
  },
  computed: {
    charCount() {
      return this.inputText.length
    }
  },
  methods: {
    updateCharCount() {
      if (this.inputText.length > 150) {
        this.inputText = this.inputText.slice(0, 150)
      }
    },
    clearInput() {
      this.inputText = ''
      this.selectedItems = []
    },
    handleKeywordAIButtonClick() {
      this.isActive = true
      setTimeout(() => {
        this.isActive = false
      }, 3000)
    },
    selectItem(item) {
      if (this.selectedItems.includes(item)) {
        // If the item is already selected, remove it
        this.selectedItems = this.selectedItems.filter((selected) => selected !== item)

        // Update inputText by removing the item
        const itemsArray = this.inputText.split(',').filter((text) => text.trim() !== item)
        this.inputText = itemsArray.join(',')
      } else {
        // If the item is not selected, add it
        if (this.inputText.length > 0) {
          this.inputText += `,${item}`
        } else {
          this.inputText = item
        }
        this.selectedItems.push(item)
      }
    },
    goBack() {
      this.$router.back() // 或者使用 this.$router.go(-1) 返回前一个页面
    }
  },
  watch: {
    inputText(newText) {
      const currentItems = newText.split(',').filter((text) => text.trim() !== '')
      this.selectedItems = currentItems
    }
  }
}
</script>



<style>
@import "LetterLogo.css";
</style>
